import thunk from 'redux-thunk';
import { addMiddleware } from 'redux-dynamic-middlewares';
import clientFactory from '../clientFactory';
import httpLink from '../links/httpLink';
import accessTokenLink from '../links/accessTokenLink';
import refreshTokenLink from '../links/refreshTokenLink';
import errorHandlingLink from '../links/errorHandlingLink';
import requestQueueMiddleware from '../links/requestQueueLink';
import checkUpdateAfterware from '../links/checkUpdateLink';
import websocketStatusLink from '../links/websocketStatusLink';

const defaultClient = clientFactory([
  errorHandlingLink,
  refreshTokenLink,
  requestQueueMiddleware,
  checkUpdateAfterware,
  accessTokenLink,
  websocketStatusLink,
  httpLink,
]);

addMiddleware(thunk.withExtraArgument(defaultClient));

export default defaultClient;
